<ng-container *transloco="let t">
  <nav (click)="onNavItemClick($event)">
    <a class="ui-item-link" [routerLink]="['/']">
      <pxw-icon class="nav-icon" icon="home"></pxw-icon>
      <span class="nav-text">{{ t('sideMenu.home') }}</span>
    </a>
    @if (infoEnabled()) {
      <button class="ui-item-link" (click)="onClickInfo()">
        <pxw-icon class="nav-icon" icon="info"></pxw-icon>
        <span class="nav-text">{{ t('sideMenu.info') }}</span>
      </button>
    }
    @if (subsidiarySelector()) {
      <button class="ui-item-link" (click)="onClickSubsidiaries()">
        <pxw-icon class="nav-icon" icon="store"></pxw-icon>
        <span class="nav-text">{{ t('sideMenu.subsidiaries') }}</span>
      </button>
    }
    @if (locationEnabled()) {
      <button class="ui-item-link" (click)="onClickLocation()">
        <pxw-icon class="nav-icon" icon="map-marker"></pxw-icon>
        <span class="nav-text">{{ t('sideMenu.location') }}</span>
      </button>
    }
    @if (establishment().links?.website) {
      <a class="ui-item-link" target="_blank" [href]="establishment().links.website">
        <pxw-icon class="nav-icon" icon="web"></pxw-icon>
        <span class="nav-text">{{ t('sideMenu.website') }}</span>
      </a>
    }
    @if (establishment().links?.instagram) {
      <a class="ui-item-link" target="_blank" [href]="establishment().links.instagram">
        <pxw-icon class="nav-icon" icon="instagram"></pxw-icon>
        <span class="nav-text">{{ t('sideMenu.instagram') }}</span>
      </a>
    }
    @if (establishment().links?.facebook) {
      <a class="ui-item-link" target="_blank" [href]="establishment().links.facebook">
        <pxw-icon class="nav-icon" icon="facebook"></pxw-icon>
        <span class="nav-text">{{ t('sideMenu.facebook') }}</span>
      </a>
    }
    @if (establishment().links?.twitter) {
      <a class="ui-item-link" target="_blank" [href]="establishment().links.twitter">
        <pxw-icon class="nav-icon" icon="twitter"></pxw-icon>
        <span class="nav-text">{{ t('sideMenu.twitter') }}</span>
      </a>
    }
    @if (establishment().links?.tiktok) {
      <a class="ui-item-link" target="_blank" [href]="establishment().links.tiktok">
        <pxw-icon class="nav-icon" icon="tiktok"></pxw-icon>
        <span class="nav-text">{{ t('sideMenu.tiktok') }}</span>
      </a>
    }
    <!-- FEATURE: WHITE_LABEL_BRANDING -->
    @if (!hasFeatureWhiteLabelBranding()) {
      <a
        class="side-menu__pedix ui-item-link"
        [href]="landingUrl"
        target="_blank"
        (click)="onInterestInPedix()"
      >
        {{ t('sideMenu.pedix') }}
      </a>
    }
  </nav>

  <pxw-modal-dialog #infoDialog type="modal" [showCloseButton]="true" [title]="t('sideMenu.info')">
    <pxw-icon icon="info" />
    <ng-template #modalContent>
      <app-establishment-info
        [establishment]="establishment()"
        [displayName]="subsidiarySelector()"
        [displayContactInfo]="true"
        [displayWorkingDays]="true"
      />
    </ng-template>
  </pxw-modal-dialog>

  <pxw-modal-dialog
    #locationDialog
    [title]="t('sideMenu.location')"
    type="modal"
    [showCloseButton]="true"
  >
    <pxw-icon icon="map-marker" />
    <ng-template #modalContent>
      <app-establishment-info
        [establishment]="establishment()"
        [displayAddress]="true"
        [displayMap]="true"
      />
    </ng-template>
  </pxw-modal-dialog>
</ng-container>
